import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Box from '@mui/material/Box';
import { styled } from "@mui/material/styles";
import { IoClose, IoSearch } from "react-icons/io5";
import InputBase from '@mui/material/InputBase';
import { alpha } from '@mui/material/styles';
import { AnimatePresence, motion } from "framer-motion";
import Divider from '@mui/material/Divider';
import { MoonLoader } from "react-spinners";
import { Suggestions } from "./Suggestions";
import { useLazyQuery, useMutation } from '@apollo/client';
import { EXECUTE_SEARCH_QUERY } from 'Graph/ReportGraph';
import { SAVE_SEARCH_MUTATION } from 'Graph/UserGraph';
import { searchUsingURL } from '../../utils/search/search';

var _ = require('lodash');

const SearchBarContainer = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  display: `flex`,
  flexDirection: `column`,
  borderRadius: theme.spacing(1),
  backgroundColor: alpha(theme.palette.secondary.main, 0.85),
  '&:focus': {
    backgroundColor: theme.palette.secondary.main,
    outline: 'none',
    '&::placeholder': {
      opacity: 0,
    }
  },
  width: '50%',
  // minWidth: '300px',
  height: '2em',
}));

const SearchInputContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '2em',
  display: `flex`,
  alignItems: `center`,
  borderRadius: theme.spacing(1),
  position: 'relative',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`

}));


const SearchIcon = styled('span')`
  color: #bebebe;
  font-size: 16px;
  margin-right: 10px;
  margin-top: 6px;
  vertical-align: middle;
  color: #bebebe;
`;

const SearchInput = styled(InputBase)`
  .MuiInputBase-root {
      width: 100%;
      display: flex;
      flex-direction: row;
  }

  .MuiInputBase-input {
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
    font-size: 16px;
    color: #12112e;
    font-weight: 500;
    border-radius: 6px;

    &:focus {
      outline: none;
      &::placeholder {
        opacity: 0;
      }
    }
    &::placeholder {
      color: #bebebe;
      transition: all 250ms ease-in-out;
    }
  }
  `;

const CloseIcon = styled(motion.span)`
  color: #bebebe;
  font-size: 16px;
  vertical-align: middle;
  transition: all 200ms ease-in-out;
  cursor: pointer;
  &:hover {
    color: #dfdfdf;
  }
`;

const StyledDivider = styled(Divider)`
  flex: 1 0 auto;
  width: 100%;
  min-height: 2px;
  background-color: ${({ theme }) => alpha(theme.palette.secondary.main, 0.35)};
`;
const SearchContent = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1em;
  overflow-y: auto;
`;

const LoadingWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WarningMessage = styled('span')`
  color: #a1a1a1;
  font-size: 14px;
  display: flex;
  align-self: center;
  justify-self: center;
`;
const containerVariants = {
  expanded: {
    height: "15em",
    y: "6.5em",
    opacity: 1
  },
  collapsed: {
    height: "2em",
    y: 0,
    opacity: 0.5
  },
};

const containerTransition = { type: "spring", damping: 22, stiffness: 150 };

const GlobalSearchBar = () => {

  const navigate = useNavigate();
  const [cursor, setCursor] = useState("")

  const [searchQuery, setSearchQuery] = useState("");
  const [isExpanded, setExpanded] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [nodes, setNodes] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const inputRef = useRef();
  // const search = searchQuery.length > 3 ? searchQuery : ""
  const [saveSearch, saveSearchResult] = useMutation(SAVE_SEARCH_MUTATION);
  const [executelazySearch, lazySearchResults] = useLazyQuery(EXECUTE_SEARCH_QUERY, {
    fetchPolicy: 'cache-and-network', // Used for first execution
    // nextFetchPolicy: 'cache-and-network', // Used for subsequent executions
    // pollInterval
    notifyOnNetworkStatusChange: true,
    variables: {
      cursor: cursor,
      search: searchQuery
    }
  });

  useEffect(() => {
    let search = searchUsingURL(location)
    if (search) {
      setSearchQuery(search)
      executelazySearch({
        variables: {
          cursor: "",
          search: search || ''
        },
        onCompleted: ((data) => {
          // console.log(rd, "this is route data on complete")
          let nodes = data.executeSearch.edges.map((edge) => edge.node)
          if (data.executeSearch.totalCount == 0) {
            setNoResults(true)
          } else {
            setNodes(nodes)
            setSuggestions(_.uniqWith(nodes, _.isEqual))
          }
        })
      })
    }
  }, [])

  const loading = lazySearchResults.loading
  const called = lazySearchResults.called
  // const totalCount = lazySearchResults.data?.executeSearch.totalCount

  useEffect(() => {
    if (nodes.length !== 0) setSuggestions(_.uniqWith(nodes, _.isEqual))
    console.log("are results empty", searchQuery, nodes)
  }, [searchQuery])


  const expandContainer = () => {
    setExpanded(true);
  };

  const collapseContainer = () => {
    setExpanded(false);
    setSearchQuery("");
    setNoResults(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  // const debouncedResults = useMemo((input) => {
  //   return debounce(() => setSearchQuery(input), 300);
  // }, []);

  const changeHandler = (e) => {
    // e.preventDefault();
    let input = e.target.value.toLowerCase();
    if (input === "") {
      setNoResults(false)
    } else {
      setSearchQuery(input)
    }
  };

  const onKeyDown = (e) => {
    let searchTerm = e.target.value

    // enable suggestions for search term length greater or equal to 3
    if (searchTerm.length >= 3) {
      localStorage.setItem("searchQuery", searchTerm)
      executelazySearch({
        variables: { search: searchTerm, cursor: cursor, }
      })
    }
    // navigate to search page if pressed enter no matter the length of search term
    if (e.key === 'Enter') {
      // let searchTerm = e.target.value
      localStorage.setItem("searchQuery", searchTerm)
      executelazySearch({ variables: { search: searchTerm, cursor: cursor, } })
      saveSearch({
        variables: { search: searchTerm, location: "global", }
      })
      collapseContainer()
      navigate(`/app/explore?search=${searchTerm}`, { replace: true });
    }
  };




  // useEffect(() => {
  //   return () => {
  //     debouncedResults.cancel();
  //   };
  // });


  return (
    <ClickAwayListener onClickAway={isExpanded ? collapseContainer : _.noop}>
      <SearchBarContainer
        animate={isExpanded ? "expanded" : "collapsed"}
        variants={containerVariants}
        transition={containerTransition}
      >
        <SearchInputContainer  >
          <SearchIcon>
            <IoSearch />
          </SearchIcon>
          <SearchInput
            placeholder="Search…"
            onFocus={expandContainer}
            ref={inputRef}
            value={searchQuery}
            onChange={changeHandler}
            inputProps={{ 'aria-label': 'search' }}
            onKeyDown={onKeyDown}
            fullWidth={true}
          // defaultValue={search && search.length > 0 ? search : null}
          />
          {/* <Suggestions anchorEl={anchorEl} setAnchorEl={setAnchorEl} /> */}
          <AnimatePresence>
            {isExpanded && (
              <CloseIcon
                key="close-icon"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={collapseContainer}
                transition={{ duration: 0.2 }}
              >
                <IoClose />
              </CloseIcon>
            )}
          </AnimatePresence>
        </SearchInputContainer>
        {isExpanded && <StyledDivider />}
        <SearchContent>
          {isExpanded && searchQuery == "" && (
            <LoadingWrapper>
              <WarningMessage>Start typing to Search</WarningMessage>
            </LoadingWrapper>
          )}
          {isExpanded && loading && (
            <LoadingWrapper>
              <MoonLoader loading color="#000" size={20} />
            </LoadingWrapper>
          )}

          {isExpanded && !loading && noResults && (
            <LoadingWrapper>
              <WarningMessage>No Solutions or Reports found!</WarningMessage>
            </LoadingWrapper>
          )}
          {
            isExpanded &&
            // searchQuery &&
            suggestions.length > 0 &&
            (
              <>
                {suggestions.map((suggestion) => {

                  console.log(suggestion)
                  return (
                    <Suggestions
                      key={suggestion.id}
                      // thumbanilSrc={suggestion.image && suggestion.image.medium}
                      name={suggestion.title}
                      // reportName={suggestion.title}
                      segment={suggestion.segment.name}
                    />
                  )
                })}
              </>
            )}
        </SearchContent>
      </SearchBarContainer>
    </ClickAwayListener>
  );
};

export default GlobalSearchBar;
